<!--
  Defines headers for a <button-group>
  Designed to mimic the sizing of the buttons and inputs
-->

<template>
  <div :class="{'input-header': true, 'fixed': !!width, 'empty': !title && !$slots.default}"
    :style="width ? {flexBasis: width, width: width} : {}">
    <tooltip-icon v-if="tooltip || $slots.tooltip"
      v-bind="$attrs" :placement="placement">
      <slot name="tooltip">{{ tooltip }}</slot>
    </tooltip-icon>
    <slot>{{ title }}</slot>
  </div>
</template>

<script>
export default {
  name: 'InputHeader',
  props: {
    title: String,
    tooltip: String,
    placement: {
      type: String,
      default: 'top',
    },
    // a fixed width for non variable elements, like buttons
    width: String,
  },
}
</script>

<style lang="scss">
@import "../../element-variables.scss";

.input-header {
  color: $--color-info;
  font-weight: bold;
  font-size: $--font-size-medium;
  // do not apply padding to empty headers, else they cannot be small
  &:not(.empty) {
    padding: $input-header-padding;
  }
  // copy the flex of a variable element
  flex: $field-flex;
  // important to include padding for correct sizing
  box-sizing: border-box;
  // fixed elements don't grow or shrink
  &.fixed {
    flex: 0 0 0;
  }
}
.input-headers-group > .input-header {
  // the separation border of the headers, on the left of each element
  &:not(:first-child) {
    border-left: 1px solid $--border-color-base;
  }
  // add some negative margin to simplify width calcularion
  // despite the left margin of the container
  &:first-child {
    margin-right: -$input-header-hmargin;
    &:not(.empty) {
      padding-right: $input-header-hpadding + $input-header-hmargin;
    }
  }
  // add some negative margin to simplify width calcularion
  // despite the right margin of the container
  &:last-child {
    &.fixed {
      margin-right: -$input-header-hmargin;
      &:not(.empty) {
        padding-right: $input-header-hpadding + $input-header-hmargin;
      }
    }
    // not sure why, but works better
    &:not(.fixed) {
      margin-right: -1px - $input-header-hmargin;
      &:not(.empty) {
        padding-right: $input-header-hpadding + 1px + $input-header-hmargin;
      }
    }
  }
  // if only one header, none of that makes sense
  &:first-child:last-child {
    &.fixed, &:not(.fixed) {
      margin-right: 0;
      &:not(.empty) {
        padding-right: $input-header-hpadding;
      }
    }
  }
}
</style>
